import * as React from "react";
import styled from "react-emotion";
import { theme, mqMin, AbsOverflow } from "../../styles/theme";
import { black } from "../../styles/colors";
import { inject, observer } from "mobx-react";

const Container = styled.div`
  ${AbsOverflow};
  background: #d1f9f0;
  color: ${black};
  opacity: ${props => (props.open ? 1 : 0)};
  overflow: auto;
  transform: ${props =>
    `translateX(${props.type === props.open
      ? 0
      : props.x}%) translateY(${props.type === props.open ? 0 : props.y}%)`};
  transform-origin: center center;
  transition: all 300ms ease-in;
  overflow: "hidden";
  z-index: 1002;
`;

const MenuWrap = ({ children, type, x = 0, y = 0, open, toggleMenu }) => {
  return (
    <Container
      open={open}
      x={x}
      y={y}
      type={type}
      onClick={open ? null : () => toggleMenu()}
    >
      {children}
    </Container>
  );
};

export default inject(({ store }) => ({
  toggleMenu: store.appStore.toggleMenu,
  type: store.appStore.menu.type
}))(observer(MenuWrap));



// WEBPACK FOOTER //
// ./src/components/MenuWrap/index.js